import { createSelector } from 'reselect';
import { extractRequestable } from '~/utils/fetchable';
import { ApplicationState } from '../store';

export const getTrackingSettingsStore = (state: ApplicationState) => state.trackingSettings;

export const getTrackingConfig = createSelector(getTrackingSettingsStore, (store) => {
  return (
    extractRequestable(store.trackingConfig) || {
      returnPolicySource: null,
      returnPolicyUrl: null,
      spotlightTitle: null,
      recommendationTitle: null,
      recommendationTitleTracking: null,
    }
  );
});

export const getTrackingConfigIsLoading = createSelector(getTrackingSettingsStore, (store) => {
  return store.trackingConfig.kind === 'requesting';
});

export const getTrackingConfigUpdateStatus = createSelector(getTrackingSettingsStore, (store) => {
  return store.trackingConfigUpdateRequest.kind;
});

export const getTrackingConfigUpdateRequest = createSelector(getTrackingSettingsStore, (store) => {
  return store.trackingConfigUpdateRequest;
});

export const getBrandAndFooterUpdateStatus = createSelector(
  getTrackingSettingsStore,
  (store) => store.brandAndFooterUpdateRequest.kind,
);
